module.exports = __webpack_public_path__ + "img/imbox-icon.ffdab3c8.svg";